import axios from "axios";

// const baseUrl = process.env.NODE_ENV=='production'?'http://dzbus.iot.xin:8082':'http://192.168.8.34:8080'
const baseUrl =
  process.env.NODE_ENV == "production"
    ? "http://dzbus.iot.xin:8082"
    : "http://192.168.8.34:8080";

const payUrl =
  process.env.NODE_ENV == "production"
    ? "https://payment.iot.xin"
    : "https://hsq0hboa5g7r.ngrok.xiaomiqiu123.top";
// const baseUrl = 'http://47.106.143.169:8082'

const mobile = {
  sendPhone(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/wpckz",
      method: "post",
      data: params,
      msg: true
    });
  },
  sendCar(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/affirm",
      params: params,
      msg: true
    });
  },
  getCarin(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/fee",
      method: "post",
      data: params,
      msg: true
    });
  },
  getCarinBranch(params) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/findFee",
      data: params,
      method: "POST",
      msg: true
    });
  },
  getCarinByMsg(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/outfindmsg",
      params: params
    });
  },
  getCode(params) {
    console.log(params);
    return axios({
      url: payUrl + "/xsq/web/wx/getcode",
      params: params
    });
  },
  payByWx(data) {
    return axios({
      url: payUrl + "/xsq/web/wx/jsapi",
      method: "post",
      data
    });
  },
  payByZfb(data) {
    return axios({
      url: payUrl + "/xsq/web/zfb/zfbwap",
      method: "post",
      data
    });
  },
  payReturn(params) {
    return axios({
      url: baseUrl + "/api/park/xsq/mobile/park/qrcode/payreturn",
      params: params,
      msg: true
    });
  },
  getRuleList() {
    return axios({
      url: "/business/discount/rules",
      method: "POST"
    });
  },
  buyRule(params) {
    return axios({
      url: "/business/discount/buydiscount",
      method: "GET",
      params
    });
  },
  getUserMoney(params) {
    return axios({
      url: `/business/user/blance/${params}`
    });
  },
  testCallback() {
    return axios({
      url: baseUrl + `/api/park/xsq/web/park/http/test`
    });
  },
  openPark(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/autoWhite",
      method: "POST",
      data
    });
  },
  openParkByPhone(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/unLicence",
      method: "POST",
      data
    });
  },
  getCodeDetail(data) {
    return axios({
      url: "/business/discount/findQrCodeIntime",
      method: "POST",
      data
    });
  },
  checkCode(params) {
    return axios({
      url: "/business/discount/checkDisQrCode",
      params
    });
  },
  submitCode(data) {
    return axios({
      url: "/business/discount/addQrCodeAllot",
      method: "POST",
      data
    });
  },
  //扫码开卡/充值输入车牌查询
  getQrcodeFindScan(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/findScan",
      method: "POST",
      data
    });
  },
  //扫码开卡及创建充值订单
  createOrder(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/scanRecharge",
      method: "POST",
      data
    });
  },
  //缴费历史记录
  rechargeRecordList(data) {
    return axios({
      url: baseUrl + "/api/unattend/xsq/mobile/park/qrcode/getRecord",
      method: "POST",
      data
    });
  },
  creatOrder(data) {
    return axios({
      url:
        baseUrl + "/api/unattend/xsq/web/passmonitor/wyfx/qrcode/genterorder",
      method: "POST",
      data
    });
  },
  getAdvertising(params) {
    return axios({
      url:
        baseUrl +
        `/api/unattend/xsq/mobile/park/qrcode/anbo_parkid/${params.parkNo}/${
          params.number
        }`,
      method: "GET"
    });
  },
  getAdvertising_th(data) {
    return axios({
      url: baseUrl + `/api/unattend/xsq/mobile/park/qrcode/getad`,
      method: "POST",
      data
    });
  }
};

export default mobile;



// WEBPACK FOOTER //
// ./src/models/mobile.js